import React from 'react';
import ReactPlayer from 'react-player';

function InstallationContent() {
 return (
   <>
     <p>RepoPrompt is a native macOS application that helps you leverage AI to understand, modify, and enhance your codebase. Follow these simple steps to get started.</p>
     
     <h3>System Requirements</h3>
     <ul>
       <li><strong>Operating System:</strong> macOS 14.0 (Sonoma) or higher</li>
       <li><strong>Disk Space:</strong> At least 100MB of free space</li>
       <li><strong>Memory:</strong> 8GB RAM recommended for optimal performance</li>
     </ul>
     
     <h3>Download and Installation</h3>
     <ol>
       <li>
         <p>Download the latest version from our official website</p>
         
         <div className="download-button-container">
           <a href="https://d2ruaev2blr0t3.cloudfront.net/RepoPrompt.dmg" className="cta-button" target="_blank" rel="noopener noreferrer">
             Download for Mac
           </a>
         </div>
       </li>
       <li>Once the download completes, open the <strong>RepoPrompt.dmg</strong> file from your Downloads folder</li>
       <li>In the window that appears, drag the RepoPrompt icon to the Applications folder</li>
       <li>Close the installer window and eject the disk image</li>
       <li>Find the app using spotlight and add it to your dock!</li>
     </ol>
     
     <h3>Getting Started</h3>
     <p>We recommend watching our tutorial video to quickly understand RepoPrompt's powerful features:</p>
     
     <div style={{ marginBottom: '1.5rem' }}>
       <div className="player-wrapper">
         <ReactPlayer
           url="https://youtu.be/fm3VreCt-5E?si=W088J7lKF_snoV8_"
           playing={false}
           loop={true}
           muted={false}
           playsinline={true}
           controls={true}
           width="100%"
           height="100%"
           className="react-player"
         />
       </div>
     </div>
     
     <p>
       For more in-depth tutorials, check out our complete
       <a href="..." target="_blank" rel="noopener noreferrer"> RepoPrompt Tutorial Playlist</a>
     </p>
     
     <h3>Free Tier and License Activation</h3>
     <p>RepoPrompt offers a generous free tier that includes:</p>
     <ul>
       <li>Access to all core features with a 32k token limit for copying and chatting</li>
       <li>The ability to connect to your own AI providers (OpenAI, Anthropic, etc.) with your API keys</li>
       <li>Full file selection, workspace management, and Apply Mode capabilities</li>
     </ul>
     
     <p>The 32k token limit is sufficient for most use cases, as model response quality tends to degrade beyond this limit. If you find yourself hitting this limit frequently, consider being more selective with your file choices to create more focused and effective prompts.</p>
     
     <p>To unlock unlimited tokens and advanced features, you can purchase a Pro license:</p>
     <ul>
       <li>Visit <a href="https://repoprompt.com/pricing" target="_blank" rel="noopener noreferrer">repoprompt.com/pricing</a> for current pricing options</li>
       <li>Complete your purchase to receive a license key via email</li>
       <li>In Repo Prompt, click on the Activate button on the top bar</li>
       <li>Enter your license key and click "Activate"</li>
       <li>Your license can be active on up to 3 machines at once</li>
     </ul>
     
     <div className="tip-box">
       <strong>Tip:</strong>
       <p>The free tier is an excellent way to evaluate RepoPrompt's capabilities. When working within the token limit, focus on selecting only the most relevant files for your current task rather than including your entire codebase. This approach not only helps stay within limits but often results in more precise AI responses.</p>
     </div>
   </>
 );
}

export default InstallationContent;